export const ENTITY_NOT_FOUND_ERROR = "ENTITY_NOT_FOUND";

export const INTERNAL_SERVER_ERROR = "SERVER_ERROR";
